import * as React from "react";

const useLazyImport = (
  path,
  onClose,
  getShopDetails,
  setStepIndex = () => {}
) => {
  const Component = React.lazy(path);
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Component
        onClose={onClose}
        getShopDetails={getShopDetails}
        setStepIndex={setStepIndex}
      />
    </React.Suspense>
  );
};

export default useLazyImport;
